"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const GradientButton_1 = require("../GradientButton");
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const purchases_1 = require("../../services/purchases");
const useAppMessage_1 = require("../../hooks/useAppMessage");
const PricingCard = ({ title, price, summaries, messages, isPopular = false, features, planId, }) => {
    const { request } = (0, useRequest_1.default)();
    const scaleValue = new react_native_1.Animated.Value(1);
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const handlePurchase = async () => {
        const isMacOSSafariWebView = /Macintosh.*AppleWebKit(?!.*Safari)/.test(navigator.userAgent);
        if (isMacOSSafariWebView) {
            showNotification("You can't upgrade to premium in the app, We know, it's not ideal", 'info');
            return;
        }
        try {
            const response = await request(purchases_1.checkout, planId);
            if (response) {
                window.location.href = response;
            }
        }
        catch (error) {
            console.error('Error initiating checkout:', error);
        }
    };
    const handlePointerEnter = () => {
        react_native_1.Animated.spring(scaleValue, {
            toValue: 1.05,
            useNativeDriver: true,
        }).start();
    };
    const handlePointerLeave = () => {
        react_native_1.Animated.spring(scaleValue, {
            toValue: 1,
            useNativeDriver: true,
        }).start();
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: { transform: [{ scale: scaleValue }] }, onPointerEnter: handlePointerEnter, onPointerLeave: handlePointerLeave, children: (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { start: { x: 0, y: 0 }, end: { x: 0, y: 1 }, colors: [colors_1.Colors.DARK_600, colors_1.Colors.DARK_600], style: [styles.container, isPopular && styles.popularContainer], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.content, children: [isPopular && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.popularBadge, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.badgeText, children: "Most Popular" }) })), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.titleText, children: title }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.priceContainer, children: (0, jsx_runtime_1.jsxs)(AppText_1.AppText, { style: styles.priceText, children: ["$", price] }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.summariesBox, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.summaryItem, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.summaryNumber, children: summaries }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.summaryLabel, children: "summaries" })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.verticalLine }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.summaryItem, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.summaryNumber, children: messages }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.summaryLabel, children: "messages" })] })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.featuresList, children: features.map((feature, index) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.featureItem, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheckCircle, color: colors_1.Colors.PRIMARY_300, size: 20 }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.featureText, children: feature })] }, index))) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonContainer, children: (0, jsx_runtime_1.jsx)(GradientButton_1.GradientButton, { text: "Buy Now", fullWidth: false, onPress: handlePurchase, customStyles: {
                                button: isPopular ? styles.popularButton : styles.standardButton,
                                text: styles.buttonText
                            } }) })] }) }) }));
};
const styles = react_native_1.StyleSheet.create({
    container: {
        borderRadius: 16,
        borderWidth: 1,
        borderColor: colors_1.Colors.DARK_400,
    },
    popularContainer: {
        borderColor: colors_1.Colors.PRIMARY_300,
        shadowColor: colors_1.Colors.PRIMARY_300,
        shadowOpacity: 0.2,
        shadowRadius: 16,
        elevation: 8,
    },
    content: {
        padding: 24,
        position: 'relative',
    },
    popularBadge: {
        position: 'absolute',
        top: -12,
        alignSelf: 'center',
        backgroundColor: colors_1.Colors.PRIMARY_300,
        paddingHorizontal: 16,
        paddingVertical: 4,
        borderRadius: 20,
    },
    badgeText: {
        color: colors_1.Colors.PRIMARY_700,
        fontSize: 14,
        fontWeight: '600',
    },
    titleText: {
        color: 'white',
        fontSize: 24,
        fontWeight: '600',
        marginBottom: 8,
    },
    priceContainer: {
        flexDirection: 'row',
        alignItems: 'baseline',
        marginBottom: 24,
    },
    priceText: {
        color: 'white',
        fontSize: 36,
        fontWeight: '600',
    },
    priceSubtext: {
        color: colors_1.Colors.DARK_100,
        fontSize: 16,
    },
    summariesBox: {
        backgroundColor: `${colors_1.Colors.DARK_500}80`,
        borderRadius: 12,
        padding: 16,
        marginBottom: 24,
        flexDirection: 'row',
        alignItems: 'center',
    },
    summaryItem: {
        flex: 1,
        alignItems: 'center',
    },
    summaryNumber: {
        color: colors_1.Colors.PRIMARY_300,
        fontSize: 20,
        fontWeight: '600',
    },
    summaryLabel: {
        color: 'white',
    },
    verticalLine: {
        width: 1,
        height: '100%',
        backgroundColor: colors_1.Colors.DARK_400,
        marginHorizontal: 8,
    },
    featuresList: {
        marginBottom: 24,
    },
    featureItem: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 12,
        paddingLeft: 4,
    },
    featureText: {
        color: colors_1.Colors.DARK_100,
        fontSize: 16,
        marginLeft: 8,
    },
    buttonContainer: {
        width: '100%',
    },
    standardButton: {
        backgroundColor: colors_1.Colors.DARK_500,
        width: '100%',
    },
    popularButton: {
        backgroundColor: colors_1.Colors.PRIMARY_300,
        width: '100%',
    },
    buttonText: {
        fontWeight: '600',
    },
});
exports.default = PricingCard;
